export const paymentStatus = [
  {
    path: '/falha-no-pagamento',
    name: 'payment-denied',
    component: () => import('@/views/payment/PaymentDenied.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'Pagamento',
      },
    },
  },
  {
    path: '/pagamento-aprovado',
    name: 'payment-success',
    component: () => import('@/views/payment/PaymentSuccess.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: '',
      },
    },
  },
];
